<template>
    <v-hover v-slot:default="{ hover }">
        <div
            :class="[
                transparent ? 'button-transparent' : '',
                fullWidth?'full-width':'',
                $route.name === 'calendar' ? 'my-1 calendar_select_button d-block' : 'my-1 filter-select-button d-block'
            ]"
            :style="customStyle"
            v-on="on"
        >
            <v-badge
                :value="!!badge && !noBadge"
                overlap
                left
                color="primary"
                class="filter-bar-badge"
                :content="badge"
            >
                <v-row align="center" no-gutters style="height: 38px" class="px-2 flex-nowrap">
                    <v-col class="shrink">
                        <div class="mx-1">
                            <icon
                                v-if="icon"
                                :size="iconSize ? iconSize : '18'"
                                :color="hover || !!badge ? 'primary' : iconColor ? iconColor : ''"
                                :icon="icon"
                            />
                        </div>
                    </v-col>
                    <v-col class="shrink" style="white-space: nowrap">
                        <span
                            v-show="showLabel" class="mx-1 body-2 tabular-nums"
                            :class="hover ? 'primary--text' : (filterActiveClass ? filterActiveClass : 'text--main text--lighten-1') "
                        >
                            {{ label }}
                        </span>
                        <span
                            v-show="!showLabel"
                            class="filter-select-input mx-1"
                            :class="hover ? 'primary--text' : 'text--main text--lighten-1'"
                            aria-label="label"
                        >
                            <slot name="value" />
                        </span>
                    </v-col>
                    <v-col class="shrink">
                        <div v-if="appendIcon" class="mx-1">
                            <icon :icon="appendIcon" />
                        </div>
                    </v-col>
                    <v-col v-if="showNavigationButtons" class="shrink d-flex">
                        <icon-button @click.stop="$emit('navigate-prev')">
                            mdi-chevron-left
                        </icon-button>
                        <icon-button @click.stop="$emit('navigate-next')">
                            mdi-chevron-right
                        </icon-button>
                    </v-col>
                    <div style="position: relative; height: 38px; width: 0;">
                        <div
                            v-show="removable"
                            :class="[
                                focused ? 'active-filter-button' : '',
                                transparent ? 'slot-gradient-white' : 'slot-gradient'
                            ]"
                        >
                            <icon-button
                                :color="hover ? 'primary' : 'grey darken-2'"
                                :icon="removeIcon"
                                @click.stop="$emit('remove')"
                            />
                        </div>
                    </div>
                </v-row>
            </v-badge>
        </div>
    </v-hover>
</template>

<script>
/*
 *
 *  This is a modified copy of the original Pieces/SelectButton.vue file. Due to parallel development.
 *
 */

export default {
    name: "FilterSelectButton",
    props: {
        filterActiveClass: {
            type: String,
            default: ""
        },
        badge: {
            type: [String, Number],
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: ""
        },
        removeIcon: {
            type: String,
            default: ""
        },
        showLabel: {
            type: Boolean,
            default: false
        },
        focused: {
            type: Boolean,
            default: false
        },
        removable: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ""
        },
        isText: {
            type: String,
            default: ""
        },
        transparent: {
            type: Boolean,
            default: false
        },
        on: {
            type: Object,
            default: () => ({})
        },
        appendIcon: {
            type: String,
            default: ""
        },
        iconSize: {
            type: String,
            default: ""
        },
        iconColor: {
            type: String,
            default: ""
        },
        noBadge: {
            type: Boolean
        },
        fullWidth:{
            type: Boolean,
            default: false
        },
        customStyle:{
            type: [String, Object],
            default: ""
        },
        showNavigationButtons: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style scoped lang="scss">
.filter-active-class {
    color: var(--v-main-base);
    font-weight: 400;
}
.full-width{
  float: initial !important;
}

.filter-select-button {
    display: block;
    float: left;
    background-color: var(--v-g3-base);
    border-radius: 8px;
    margin-right: 10px;
    transition: background-color 0.1s ease-in;
    cursor: pointer;
    .slot-gradient,
    .slot-gradient-white {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.1s ease-in;
    }
    &.button-transparent {
        background-color: transparent;
    }
}

.calendar_select_button {
  @extend .filter-select-button;
  background-color: var(--v-shade_color-base);
}

input {
    width: auto;
}
</style>
